import { Component } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
})

export class ResetPasswordComponent {

  requested: boolean = false;

  resetPasswordForm: UntypedFormGroup = new UntypedFormGroup({
    email: new UntypedFormControl('', Validators.required),
  });

  constructor(
    private _translateService: TranslateService,
    private dataService: DataService,
    private router: Router,
    private snackBar: MatSnackBar,
  ) {}

  reset() {
    this.dataService.resetPassword(this.resetPasswordForm.get('email')?.value).subscribe(val => {
      if (val) {
        this.requested = true;
        this.snackBar.open(
          this._translateService.instant('login.requested1'),
          undefined,
          { duration: 4000 }
        );
        setTimeout(() => this.router.navigate(['/login']), 4000);
      }
    });
  }
}
